module.exports = __webpack_public_path__ + "img/stato-pagamenti-emt.1e46af67.png";